const POST_AUTH_REDIRECT_KEY = 'postAuthRedirect';

export const setPostAuthRedirect = (path?: string): void => {
  const fullPath = path || `${window.location.pathname}${window.location.search}`;
  if (fullPath !== '/') {
    window.sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, fullPath);
  }
};

export const handlePostAuthRedirect = (): void => {
  const redirectPath = window.sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  if (redirectPath && redirectPath !== `${window.location.pathname}${window.location.search}`) {
    window.sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
    window.location.href = redirectPath;
  }
};
